// Notifikationshjälpfunktioner
import { PrayerTimesResponse } from "./prayerTimesAPI";
import { quietLog } from "./prayerTimesAPI";

export const scheduleIftarNotification = (
  prayerTimes: PrayerTimesResponse,
  minutesBefore: number = 30,
  soundEnabled: boolean = false,
  prayerName: string = "iftar"
) => {
  if (!("Notification" in window)) {
    console.log("Denna webbläsare stödjer inte aviseringar");
    return;
  }

  if (Notification.permission !== "granted") {
    console.log("Behörighet för aviseringar har inte beviljats");
    return;
  }

  const maghribTime = prayerTimes.prayerTimes.maghrib;
  const [hours, minutes] = maghribTime.split(":").map(Number);
  
  const notificationTime = new Date();
  notificationTime.setHours(hours, minutes, 0, 0);
  notificationTime.setMinutes(notificationTime.getMinutes() - minutesBefore);
  
  const now = new Date();
  
  // Om aviseringstiden är i det förflutna, schemalägg inte
  if (notificationTime <= now) {
    console.log("Aviseringstiden är i det förflutna, schemalägger inte");
    return;
  }
  
  const timeUntilNotification = notificationTime.getTime() - now.getTime();
  
  // Använd korrekt bönnamn i notifikationen
  const formattedPrayerName = prayerName.charAt(0).toUpperCase() + prayerName.slice(1);
  
  // Schemalägg avisering
  setTimeout(() => {
    const notification = new Notification(`${formattedPrayerName}-tid närmar sig`, {
      body: `${formattedPrayerName}-tiden börjar om ${minutesBefore} minuter (${maghribTime})`,
      icon: "/icon-192x192.png", 
    });
    
    if (soundEnabled) {
      // Spela aviseringsljud
      const audio = new Audio("/notification-sound.wav");
      audio.play().catch(e => quietLog("Kunde inte spela aviseringsljud", e));
    }
    
    // Stäng aviseringen automatiskt efter 10 sekunder
    setTimeout(() => notification.close(), 10000);
  }, timeUntilNotification);
  
  console.log(`Avisering schemalagd för ${notificationTime.toLocaleTimeString()}`);
};

// Funktion för att begära behörighet för aviseringar
export const requestNotificationPermission = async (): Promise<boolean> => {
  if (!("Notification" in window)) {
    console.log("Denna webbläsare stödjer inte aviseringar");
    return false;
  }

  if (Notification.permission === "granted") {
    return true;
  }

  if (Notification.permission !== "denied") {
    const permission = await Notification.requestPermission();
    return permission === "granted";
  }

  return false;
};

// Funktion för att konfigurera aviseringar baserat på inställningar
export const setupNotifications = async (
  prayerTimes: PrayerTimesResponse
) => {
  try {
    // Hämta notifikationsinställningar från localStorage
    const savedSettings = localStorage.getItem("notificationSettings");
    if (savedSettings) {
      const settings = JSON.parse(savedSettings);
      
      if (settings.enabled) {
        const permissionGranted = await requestNotificationPermission();
        
        if (permissionGranted) {
          // Använd reminderTime från inställningarna
          const reminderTime = settings.reminderTime || 15;
          const prayerName = settings.nextPrayer || "maghrib";
          console.log(`Setting up notifications with reminder time: ${reminderTime} minutes for ${prayerName}`);
          
          scheduleIftarNotification(
            prayerTimes, 
            reminderTime, 
            settings.soundEnabled,
            prayerName
          );
        }
      }
    }
  } catch (error) {
    quietLog("Fel vid inställning av aviseringar", error);
  }
};

// Ta bort den duplicerade setupNotifications-funktionen här
